export const makeBreakpoint = () => ({ smAndDown: window.innerWidth < 1100 });
